import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_gifts_occasion: FaireCategoryEntity = {
  token: "cat_gifts-occasion",
  type: "category",
  name: "By occasion",
  level: 2,
  parentToken: "cat_gifts",
  href: "/category/gifts/occasion",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
